export const blogCategory = [
  {
    name: "Terbaru",
    codename: "terbaru",
    id: 0
  },
  {
    name: "Terpopuler",
    codename: "terpopuler",
    id: 1
  },
  {
    name: "Literasi Keuangan",
    codename: "literasi_keuangan",
    id: 2
  },
  {
    name: "Pembiayaan Konsumen",
    codename: "pembiayaan_konsumen",
    id: 3
  },
  {
    name: "Gadget",
    codename: "gadget",
    id: 4
  },
  {
    name: "Hiburan",
    codename: "hiburan",
    id: 5
  },
  {
    name: "Gaya Hidup",
    codename: "gaya_hidup",
    id: 6
  },
  {
    name: "Tips",
    codename: "tips",
    id: 7
  }
];

export const BlogTitle = {
  terbaru: {
    title: "Terbaru",
    slug: "terbaru"
  },
  terpopuler: {
    title: "Terpopuler",
    slug: "terpopuler"
  },
  literasi_keuangan: {
    title: "Literasi Keuangan",
    slug: "literasi-keuangan"
  },
  pembiayaan_konsumen: {
    title: "Pembiayaan Konsumen",
    slug: "pembiayaan-konsumen"
  },
  gadget: {
    title: "Gadget",
    slug: "gadget"
  },
  hiburan: {
    title: "Hiburan",
    slug: "hiburan"
  },
  gaya_hidup: {
    title: "Gaya Hidup",
    slug: "gaya-hidup"
  },
  tips: {
    title: "Tips",
    slug: "tips"
  }
};
